import { Link } from "react-router-dom";

import { ApiError } from "../lib/api";
import type { BackTarget } from "../lib/backNavigation";

import Spinner from "./Spinner";
import EmptyState, { emptyStateActionClass } from "./EmptyState";

export type DetailHomeLink = { to: string; label: string };

export function DetailBackNav({
  back,
  home,
}: {
  back: BackTarget;
  home?: DetailHomeLink;
}) {
  const showHome = home != null && back.to !== home.to;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
      <Link
        to={back.to}
        className="text-sm text-slate-500 underline-offset-2 hover:underline"
      >
        {back.label}
      </Link>
      {showHome && home ? (
        <Link
          to={home.to}
          className="text-sm text-slate-400 underline-offset-2 hover:text-slate-600 hover:underline"
        >
          {home.label}
        </Link>
      ) : null}
    </div>
  );
}

export function DetailQueryStatus({
  isLoading,
  error,
  loadingLabel,
  notFoundLabel,
  recovery,
  onRetry,
}: {
  isLoading: boolean;
  error: unknown;
  loadingLabel: string;
  notFoundLabel: string;
  recovery?: DetailHomeLink;
  onRetry?: () => void;
}) {
  if (isLoading) {
    return (
      <p className="mt-6 inline-flex items-center gap-2 text-sm text-slate-500">
        <Spinner /> {loadingLabel}
      </p>
    );
  }
  if (error) {
    if (recovery) {
      const status = error instanceof ApiError ? error.status : null;
      return <div className="mt-6 rounded-lg border border-slate-200 bg-white px-5">
        <EmptyState title={status === 404 ? notFoundLabel : status === 403 ? "Kein Zugriff auf diese Ansicht" : "Die Ansicht konnte nicht geladen werden"} alert={status !== 404} actions={<>
          {status !== 403 && status !== 404 && onRetry && <button type="button" className={emptyStateActionClass} onClick={onRetry}>Erneut versuchen</button>}
          <Link className={emptyStateActionClass} to={recovery.to}>{recovery.label}</Link>
        </>}>
          {status === 404 ? "Dieser Eintrag ist im aktuellen Unternehmen nicht verfügbar. Der Link kann veraltet sein. Suche nach der Nummer oder Beschreibung, um einen vorhandenen Eintrag zu finden." : status === 403 ? "Deine Zugriffsrechte erlauben das Öffnen dieses Eintrags nicht. Wende dich bei Bedarf an die Verwaltung deines Unternehmens." : "Bitte versuche es erneut. Daraus lässt sich nicht schließen, dass der Eintrag fehlt."}
        </EmptyState>
      </div>;
    }
    const message =
      error instanceof ApiError && error.status === 404
        ? notFoundLabel
        : `Fehler beim Laden: ${(error as Error).message}`;
    return (
      <p className="mt-6 rounded-md border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
        {message}
      </p>
    );
  }
  return null;
}
